export class SlideShop {
    constructor(slides, callback, loopSlide = false, loopOptions = { startTime: 1200, loopTime: 3000 }) {
        this.slides = slides;
        this.callback = callback;
        this.loopSlide = loopSlide;
        this.loopOptions = loopOptions;
    }
    onInit() {
        var _a;
        const slides = document.querySelectorAll(this.slides);
        if (slides) {
            slides[0].classList.add('abi__shop-collection-list-item-card-images-current');
            (_a = slides[0].nextElementSibling) === null || _a === void 0 ? void 0 : _a.classList.add("abi__shop-collection-list-item-card-images-next");
        }
        if (this.loopSlide) {
            setTimeout(() => {
                setInterval(() => {
                    slides.length > 1 && this.onChange(slides);
                }, this.loopOptions.loopTime);
            }, this.loopOptions.startTime);
        }
        this.callback && this.callback();
    }
    onChange(slides) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const current = Array.from(slides).filter((el) => el.classList.contains("abi__shop-collection-list-item-card-images-current"));
        (_a = current[0]) === null || _a === void 0 ? void 0 : _a.classList.add("abi__shop-collection-list-item-card-images-out");
        (_b = current[0]) === null || _b === void 0 ? void 0 : _b.classList.remove('abi__shop-collection-list-item-card-images-current', 'abi__shop-collection-list-item-card-images-next');
        (_d = (_c = current[0]) === null || _c === void 0 ? void 0 : _c.nextElementSibling) === null || _d === void 0 ? void 0 : _d.classList.add("abi__shop-collection-list-item-card-images-current");
        if (((_e = current[0]) === null || _e === void 0 ? void 0 : _e.nextElementSibling) === null) {
            (_f = slides[0]) === null || _f === void 0 ? void 0 : _f.classList.add("abi__shop-collection-list-item-card-images-current");
            (_g = slides[0].nextElementSibling) === null || _g === void 0 ? void 0 : _g.classList.add("abi__shop-collection-list-item-card-images-next");
        }
        const Newcurrent = Array.from(slides).filter((el) => el.classList.contains("abi__shop-collection-list-item-card-images-current"));
        (_j = (_h = Newcurrent[0]) === null || _h === void 0 ? void 0 : _h.nextElementSibling) === null || _j === void 0 ? void 0 : _j.classList.add("abi__shop-collection-list-item-card-images-next");
        (_k = Newcurrent[0]) === null || _k === void 0 ? void 0 : _k.classList.remove("abi__shop-collection-list-item-card-images-out");
    }
    onDestroy(slides) {
        var _a;
        if (slides) {
            slides.forEach((slide) => {
                slide === null || slide === void 0 ? void 0 : slide.classList.remove('abi__shop-collection-list-item-card-images-current', 'abi__shop-collection-list-item-card-images-next', 'abi__shop-collection-list-item-card-images-out');
            });
            slides[0].classList.add('abi__shop-collection-list-item-card-images-current');
            (_a = slides[0].nextElementSibling) === null || _a === void 0 ? void 0 : _a.classList.add("abi__shop-collection-list-item-card-images-next");
        }
    }
}
